import { cast } from 'mobx-state-tree';
import { Moment } from 'moment';
import { WeekDay } from '@app-types/index';
import { SetTimeSlotConfigurationArgsWithSelf } from '../types';
import { TimeSlotConfigurationModelType } from '../../TimeSlotConfiguration';
import { getTimeSlotForAGivenDay } from './setTimeSlotConfiguration/getTimeSlotForAGivenDay';
import { TimelineItemModelType } from '../../TimelineItem';
import { getTimeLineIntervalSlotsForAllGroups } from '../helpers/getTimeLineIntervalSlotsForAllGroups';
import { refreshTimetable } from './refreshTimetable';

export const setTimeSlotConfiguration = ({
  self,
  timeSlotConfigurationsData,
  applyToAll,
}: SetTimeSlotConfigurationArgsWithSelf) => {
  if (self.week && self.timelineItems) {
    self.timeSlotConfigurations = null;
    const newTimeSlotConfigurations: TimeSlotConfigurationModelType[] = [];
    const newIntervalConfigurations: TimeSlotConfigurationModelType[] = [];

    if (applyToAll) {
      Object.entries(WeekDay).forEach((weekDay) => {
        timeSlotConfigurationsData.monday.forEach((timeSlotConfiguration) => {
          const timeSlotForAGivenDay = getTimeSlotForAGivenDay({
            week: self.week as Moment,
            timeSlotConfiguration,
            givenWeekDay: weekDay[0],
            timelineItems: self.timelineItems,
          });

          if (timeSlotForAGivenDay) {
            if (timeSlotForAGivenDay.interval) {
              newIntervalConfigurations.push(timeSlotForAGivenDay.timeSlot);
            } else {
              newTimeSlotConfigurations.push(timeSlotForAGivenDay.timeSlot);
            }
          }
        });
      });
    } else {
      Object.entries(timeSlotConfigurationsData).forEach((timeSlotDayConfiguration) => {
        timeSlotDayConfiguration[1].forEach((timeSlotConfiguration) => {
          const timeSlotForAGivenDay = getTimeSlotForAGivenDay({
            week: self.week as Moment,
            timeSlotConfiguration,
            givenWeekDay: timeSlotDayConfiguration[0],
            timelineItems: self.timelineItems,
          });

          if (timeSlotForAGivenDay) {
            if (timeSlotForAGivenDay.interval) {
              newIntervalConfigurations.push(timeSlotForAGivenDay.timeSlot);
            } else {
              newTimeSlotConfigurations.push(timeSlotForAGivenDay.timeSlot);
            }
          }
        });
      });
    }

    if (newTimeSlotConfigurations.length > 0) {
      self.timeSlotConfigurations = cast(newTimeSlotConfigurations);
    }

    // Set timetable intervals
    let timeLineIntervals: TimelineItemModelType[] = [];

    newIntervalConfigurations.forEach((intervalConfiguration) => {
      if (self.timelineGroups) {
        const timeLineIntervalSlotsForAllGroups = getTimeLineIntervalSlotsForAllGroups({
          timelineGroups: self.timelineGroups,
          startTime: intervalConfiguration.startTime,
          endTime: intervalConfiguration.endTime,
        });

        timeLineIntervals = [...timeLineIntervals, ...timeLineIntervalSlotsForAllGroups];
      }
    });

    if (timeLineIntervals.length > 0) {
      self.timelineItems = cast([...self.timelineItems, ...timeLineIntervals]);

      refreshTimetable();
    }
  }
};
